import React, { useEffect, useRef } from 'react'
import styles from './Desktop.module.scss'
import DesktopBar from './components/desktopBar/DesktopBar'
import { useSelector } from 'react-redux'
import { State } from '../../redux/store.types'
import DesktopApp from './components/desktopApp/DesktopApp'
import DesktopWindow from './components/desktopWindow/DesktopWindow'
import AppMenu from './components/appMenu/AppMenu'
import { DESKTOP_PAGES } from './desktop.constants'
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks'
import Loading from '../../components/loading/Loading'
import { selectUser } from '../../redux/slices/UserSlice/UserSlice.selectors'
import { apiGetServerUser } from 'src/api'
import { removeUser, setApps, setDesktopLoading } from 'src/redux'
import useWebsocketNotification from './hooks/useWebsocketNotification'

const Desktop = () => {
  const appContainerEl = useRef(null)

  // redux hooks
  const dispatch = useAppDispatch()

  const {
    page,
    apps,
    loading: appsLoading
  } = useSelector((state: State) => state.desktop)
  const { openedWindows } = useSelector((state: State) => state.window)
  const { token: userToken, serverUrl: serverPath } = useAppSelector(selectUser)
  useWebsocketNotification()

  const fetchApps = async () => {
    try {
      const response = await apiGetServerUser({
        serverPath,
        userToken
      })
      const { iconDataList } = response
      dispatch(setApps({ apps: iconDataList }))
      dispatch(setDesktopLoading(false))
    } catch (error) {
      dispatch(removeUser())
      console.log(error, 'error')
    }
  }

  useEffect(() => {
    fetchApps()
  }, [])

  if (appsLoading) {
    return <Loading />
  }

  return (
    <>
      {page === DESKTOP_PAGES.MENU && <AppMenu />}
      <div className={styles.desktop}>
        <div className={styles.appContainer} ref={appContainerEl}>
          {apps
            .slice()
            .sort((a, b) => {
              if (b.show && !a.show) return 1
              if (!b.show && a.show) return -1
              return 0
            })
            .map((app, id) => (
              <DesktopApp key={app.id + id} {...app} />
            ))}
          {openedWindows.map((openedWindow) => (
            <DesktopWindow
              key={`window-${openedWindow.name}-${openedWindow.id}`}
              {...openedWindow}
              appContainerEl={appContainerEl}
            />
          ))}
        </div>
        <DesktopBar />
      </div>
    </>
  )
}
export default Desktop
